export const teamMembers = [
  {
    id: 1,
    name: "Mubashir Ashraf",
    title: "CEO & Founder",
    tagline: "The Visionary",
    image: "/assets/images/team/mubashir.jpg",
    quote: "People often ask about the origin of Quavrion. In late 2024, I realized the tech industry had become a chaotic echo chamber. Every agency was screaming 'Growth'. Every startup was shouting 'AI'. I wanted Innovation to be our internal discipline, not our external marketing pitch.",
    category: "leadership"
  },
  {
    id: 2,
    name: "Sajeed Ansari",
    title: "CTO & Co-Founder",
    tagline: "The Architect",
    image: "/assets/images/team/sajeed.jpg",
    quote: "To me, technology is not about flash or hype. It is about stability. I have always believed that the best code is the one you never notice. It doesn't crash, it doesn't lag, and it doesn't scream for attention. It simply works.",
    category: "leadership"
  },
  {
    id: 3,
    name: "CA Nikhat",
    title: "Chief Strategy Officer",
    tagline: "The Calculus of Influence",
    image: "/assets/images/team/nikhat.jpg",
    quote: "Creativity without ROI is just art. My job is to ensure every pixel generates profit. I bring the financial discipline of a Chartered Accountant to the chaos of brand strategy.",
    category: "strategy"
  },
  {
    id: 4,
    name: "Faiz Ali",
    title: "Chief Solutions Architect",
    tagline: "Translating Logic into Legacy",
    image: "/assets/images/team/faiz.jpg",
    quote: "Complex problems don't need complex solutions. They need elegant architecture. I build the systems that banks and governments rely on.",
    category: "architecture"
  },
  {
    id: 5,
    name: "Jamil Ansari",
    title: "Lead Systems Engineer & Creative Technologist",
    tagline: "The Code Artist",
    image: "/assets/images/team/jamil.jpg",
    quote: "A machine can write code, but only a human can write an experience. I build the bridge between rigid backend logic and fluid user emotion.",
    category: "engineering"
  },
  {
    id: 6,
    name: "Syed Nausheen",
    title: "Head of Digital Growth & Endorsements",
    tagline: "Amplifying the Signal",
    image: "/assets/images/team/nausheen.jpg",
    quote: "In the digital age, being the 'best' isn't enough. You have to be omnipresent. I make sure the world can't scroll past your brand.",
    category: "growth"
  },
  {
    id: 7,
    name: "Muskan Chawla",
    title: "Head of Brand Outreach & Community",
    tagline: "The Social Alchemist",
    image: "/assets/images/team/muskan.jpg",
    quote: "Algorithms determine reach, but relationships determine revenue. Whether via Email or Influencers, I turn passive followers into active ambassadors.",
    category: "outreach"
  },
  {
    id: 8,
    name: "Satyam",
    title: "Head of Product Experience (UI/UX)",
    tagline: "Designing the Interface of Tomorrow",
    image: "/assets/images/team/satyam.jpg",
    quote: "The best design is invisible. It feels like reading the user's mind before they touch the screen.",
    category: "design"
  },
  {
    id: 9,
    name: "Rashid Khan",
    title: "Chief Revenue Officer",
    tagline: "The Strategist",
    image: "/assets/images/team/rashid.jpg",
    quote: "Growth is vanity, profit is sanity. I engineer the financial fuel that keeps the innovation engine running.",
    category: "finance"
  },
  {
    id: 10,
    name: "Adv. Qayammuddin",
    title: "Chief Legal Counsel",
    tagline: "The Guardian",
    image: "/assets/images/team/qayammuddin.jpg",
    quote: "Innovation needs boundaries to be safe. I build the fortress that protects our intellectual property and corporate sovereignty.",
    category: "legal"
  }
]